import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

// MUI Imports
import {
  ScheduleOutlined,
  MarkEmailReadOutlined,
  InboxOutlined,
  KeyboardArrowUp
} from '@mui/icons-material'

import McPageHelpers from '../../../../../pages/mc-components/McPageHelpers'

const dataKeys = ['incomingEmailCount', 'repliedEmailCount', 'inboxLastChecked']

const icons = {
  incomingEmailCount: InboxOutlined,
  repliedEmailCount: MarkEmailReadOutlined,
  inboxLastChecked: ScheduleOutlined
}

const getPercent = (val, total, precision = 1) => {
  const percent = val * 100 / total

  if (percent === Infinity || isNaN(percent)) {
    return null
  } else {
    return percent % 1 === 0 ? percent : percent.toFixed(precision)
  }
}

const EmailStatusItemList = ({ campaignReport }) => {
  const { t, i18n } = useTranslation()
  const [statusItems, setStatusItems] = useState([])

  const initItemListData = () => {
    const userLocale = McPageHelpers.localeMap[localStorage.getItem('lang')] || 'en-US'
    const processedStatusItems = []

    dataKeys.forEach((item) => {
      if (campaignReport?.[item] || campaignReport?.[item] === 0) {
        const value = item === 'inboxLastChecked'
          ? new Date(campaignReport[item]).toLocaleString(userLocale).split(',')[0].split(' ')[0]
          : campaignReport[item]

        const totalMail = (campaignReport?.outgoingEmailStats?.DELIVERED || 0) + (campaignReport?.outgoingEmailStats?.FAILED || 0)

        const highlightedText = item === 'repliedEmailCount'
          ? getPercent(campaignReport[item], totalMail)
          : null

        const label = t(`mailTemplate.campaigns.emailReport.${item}`)

        processedStatusItems.push({
          id: item,
          label,
          value,
          highlightedText: highlightedText
            ? <>
              <KeyboardArrowUp sx={{ width: 10, height: 10, marginLeft: 2 }}/>
              {i18n.language === 'tr' ? `%${highlightedText}` : `${highlightedText}%`}
            </>
            : null,
          icon: icons[item]
        })
      }
    })

    setStatusItems(processedStatusItems)
  }

  useEffect(() => {
    initItemListData()
  }, [campaignReport, t])

  const stats = statusItems.filter(item => item.id !== 'inboxLastChecked')
  const dateItem = statusItems.find(item => item.id === 'inboxLastChecked')
  const repliedItem = statusItems.find(item => item.id === 'repliedEmailCount')
  const highlightedText = repliedItem?.highlightedText

  return (
    <div className="w-full flex justify-between items-end pb-1 mt-3">
      <div className="flex gap-4">
        {stats.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className={`p-1.5 rounded-md ${item.id === 'incomingEmailCount' ? 'bg-blue-50 text-blue-600' : 'bg-emerald-50 text-emerald-600'}`}>
              <item.icon sx={{ width: 16, height: 16 }}/>
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-bold text-gray-700 leading-none">{item.value}</span>
              <span className="text-[10px] text-gray-400 font-medium leading-tight mt-0.5">{item.label}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col items-end gap-1">
        {highlightedText && (
          <div className="text-[10px] font-semibold text-emerald-600 bg-emerald-50 px-1 rounded flex items-center w-fit">
            {highlightedText}
          </div>
        )}
        {dateItem && (
          <div className="flex items-center gap-1.5 text-gray-400">
            <ScheduleOutlined sx={{ width: 14, height: 14 }}/>
            <span className="text-xs font-medium">{dateItem.value}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default EmailStatusItemList
